import React from 'react';
import { MyPortfolioCapsuleContentProps } from 'widgets/myPortfolioCapsules/MyPortfolioCapsuleWidgetStrategy';
import { useMyPortfolioCapsuleConfigSlice } from 'widgets/myPortfolioCapsules/store/config/configSlice';
import { rsiStreamedDataSelectors } from 'widgets/signalTiles/rsiTile/state';
import { SignalTileContent } from 'widgets/signalTiles/signalTile/components/SignalTileContent';
import { SignalTileConfigState } from 'widgets/signalTiles/signalTile/state/config/SignalTileConfigState';
import { rsiTileProps } from './rsiTileProps';
const { useSymbolStreamedData } = rsiStreamedDataSelectors;

export function RsiTileMyPortfolioCapsuleContent(
    props: MyPortfolioCapsuleContentProps
) {
    const { symbol } = props;
    const { config } =
        useMyPortfolioCapsuleConfigSlice<SignalTileConfigState>();
    const streamData = useSymbolStreamedData(symbol, config);

    return (
        <SignalTileContent
            streamData={streamData}
            config={config}
            className={'RsiTileChartContent'}
            {...rsiTileProps}
        />
    );
}
